import { useSelector } from 'react-redux';
import { getInstallableModules, getZone, getZoneModules } from '../redux/selectors/zones';
import useGruser from './useGruser';
export const useZone = (zoneName)=>{
    const { gruser } = useGruser();
    return useSelector((state)=>getZone(state, gruser, zoneName));
};
export const useZoneModules = (zoneName)=>{
    const { gruser } = useGruser();
    const installedModules = useSelector((state)=>getZoneModules(state, gruser, zoneName));
    const installableModules = useSelector((state)=>getInstallableModules(state, gruser, zoneName));
    return {
        installedModules,
        installableModules
    };
};
export default useZone;
